import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "dayWrapper";

export const classes = {
  leftBorderRadius: `${PREFIX}-leftBorderRadius`,
  rightBorderRadius: `${PREFIX}-rightBorderRadius`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  button: `${PREFIX}-button`,
  buttonText: `${PREFIX}-buttonText`,
  outlined: `${PREFIX}-outlined`,
  selected: `${PREFIX}-selected`,
  highlighted: `${PREFIX}-highlighted`,
  startOfWeekInRange: `${PREFIX}-startOfWeekInRange`,
  endOfWeekInRange: `${PREFIX}-endOfWeekInRange`,
  endOfWeekStartofMonthInRange: `${PREFIX}-endOfWeekStartofMonthInRange`,
  contrast: `${PREFIX}-contrast`,
  invisible: `${PREFIX}-invisible`,
};

export const DayWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  "& button": {
    height: 36,
    width: 36,
    padding: 0,
    lineHeight: 1.6,
  },
  [`&.${classes.leftBorderRadius}`]: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: "50% 0 0 50%",
  },
  [`&.${classes.rightBorderRadius}`]: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: "0 50% 50% 0",
  },
  [`&.${classes.highlighted}`]: {
    backgroundColor: theme.palette.primary.light,
  },
  [`&.${classes.startOfWeekInRange}`]: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: "50% 0 0 50%",
  },
  [`&.${classes.endOfWeekInRange}`]: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: "0 50% 50% 0",
  },
  [`&.${classes.endOfWeekStartofMonthInRange}`]: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: "50% 50% 50% 50%",
  },
  [`&.${classes.invisible}`]: {
    visibility: "hidden",
  },
}));

export const DayButton = styled(IconButton)(({ theme }) => ({
  [`&.${classes.outlined}`]: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  [`&.${classes.selected}`]: {
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    backgroundColor: theme.palette.primary.main,
  },
  [`&.${classes.contrast}`]: {
    "& p": {
      color: theme.palette.primary.contrastText,
    },
  },
}));
